import { AnchorHTMLAttributes, FC } from 'react';

import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router';

type InternalLinkProps = { type: 'internal' } & RouterLinkProps;
type ExternalLinkProps = { type: 'external' } & AnchorHTMLAttributes<HTMLAnchorElement>;

type Props = InternalLinkProps | ExternalLinkProps;

const InternalLink: FC<Readonly<InternalLinkProps>> = ({ type, ...rest }: InternalLinkProps) => (
	<RouterLink {...rest} />
);

const ExternalLink: FC<Readonly<ExternalLinkProps>> = ({ type, ...rest }: ExternalLinkProps) => (
	<a target="_blank" rel="noopener noreferrer" {...rest} />
);

const AppLink: FC<Readonly<Props>> = (props: Props) => {
	if (props.type === 'internal') {
		return <InternalLink {...props} />;
	}

	return <ExternalLink {...props} />;
};

export default AppLink;
